import React from 'react'

import Skeleton from '../shared/Skeleton'

const SearchBarSkeleton: React.FC = () => (
  <div
    className="flex flex-col md:justify-between items-center bg-white rounded-2xl min-h-full portrait:m-4 portrait:border portrait:border-gray-200"
    role="status"
    aria-busy="true"
  >
    <span className="sr-only">Cargando el buscador de pedidos</span>

    <div className="landscape:mt-10 mt-2 w-full landscape:gap-14 gap-6 flex flex-col items-center">
      {/* TitleContainer */}
      <div className="flex flex-col gap-4 justify-center items-center mt-4">
        <Skeleton className="md:w-5 md:h-5 md:block portrait:hidden rounded" />
        <Skeleton className="h-3.5 w-32 rounded mb-[10px]" />
      </div>

      {/* Formulario */}
      <div className="justify-center items-start md:flex-col w-full">
        <div className="flex justify-center">
          <div className="flex flex-col gap-3 portrait:w-full landscape:w-96 mx-8">
            <div className="h-14 portrait:mb-2">
              <Skeleton className="w-full h-full rounded-xl" />
            </div>

            <div className="h-12">
              <Skeleton className="w-full h-full rounded-xl" />
            </div>

            <Skeleton className="h-3 w-40 max-w-full rounded mt-5 mb-4 self-center" />
          </div>
        </div>
      </div>
    </div>

    {/* Footer */}
    <div className="landscape:block hidden mb-10 mt-6">
      <Skeleton className="h-2.5 w-24 rounded" />
    </div>
  </div>
)

export default SearchBarSkeleton
